import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-80">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-81" />

      <div className="px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto relative z-10" data-id="element-82">
        <div className="flex flex-col items-center text-center" data-id="element-83">
          {/* Top Badge */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brand-gold/30 bg-brand-gold/5 mb-8" data-id="element-84">
            <Lock className="w-4 h-4 text-brand-gold" data-id="element-85" />
            <span className="text-xs md:text-sm font-semibold tracking-widest text-brand-gold uppercase" data-id="element-86">
              Documento Confidencial • Acceso Limitado
            </span>
          </motion.div>

          {/* Headlines */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="max-w-4xl mx-auto" data-id="element-87">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-88">
              Logra erecciones{' '}
              <span className="text-brand-gold italic" data-id="element-89">
                firmes, palpitantes y primitivas
              </span>{' '}
              – Solo con el poder de tu biología interna.
            </h1>
            <p className="text-lg md:text-xl text-brand-muted max-w-2xl mx-auto mb-12" data-id="element-90">
              Descubre el documento clandestino que está devolviendo el poder a
              los hombres de habla hispana en USA.
            </p>
          </motion.div>

          {/* Ebook Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-91">
            <div className="absolute inset-0 bg-brand-gold/20 blur-[60px] rounded-full" data-id="element-92" />
            <img src="https://cdn.magicpatterns.com/uploads/pHsWPFoPzGQfqVYFgikeNp/MockUP_vf.png" alt="El Manual Prohibido Ebook" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-93" />
          </motion.div>

          {/* CTA Area */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-94">
            <Button className="w-full mb-4 group px-10" data-id="element-95">
              <span className="flex flex-col items-center justify-center gap-1" data-id="element-96">
                <span className="whitespace-nowrap text-lg md:text-xl" data-id="element-97">
                  SÍ, QUIERO RECUPERAR MI PODER
                </span>
                <span className="text-xs font-normal opacity-80 flex items-center gap-1" data-id="element-98">
                  Descubre el sistema natural aquí{' '}
                  <span className="text-base animate-bounce inline-block" data-id="element-99">
                    ⬇
                  </span>
                </span>
              </span>
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mt-2" data-id="element-100">
              <span className="flex items-center gap-1" data-id="element-101">
                <Lock className="w-3.5 h-3.5" data-id="element-102" /> Pago 100% seguro
              </span>
              <span className="hidden md:inline" data-id="element-103">•</span>
              <span className="flex items-center gap-1" data-id="element-104">
                <Zap className="w-3.5 h-3.5" data-id="element-105" /> Acceso inmediato
              </span>
              <span className="hidden md:inline" data-id="element-106">•</span>
              <span className="flex items-center gap-1" data-id="element-107">
                <Shield className="w-3.5 h-3.5" data-id="element-108" /> Garantía de 60 días
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}